import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@sigopos/ui/tokens.css'
import './app.css'
import './skin-modern.css'
import { App } from './App'
import { applySkin, readSkin } from './lib/skin'

// Gắn trước khi vẽ. Đọc sau khi vẽ thì người dùng thấy giao diện nhảy một cái lúc mở app.
applySkin(readSkin())

const root = document.getElementById('root')
if (!root) throw new Error('Không tìm thấy #root trong index.html')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
